import { companyListApi } from "../../api/company/companyListApi"

type PayloadShape = Parameters<typeof companyListApi>[0]

export async function companyListService(payload: PayloadShape, token?: null | string) {
	return await companyListApi(payload, token)
}
